import React from 'react'
import './buttons.css'
import Tooltip from '../tooltip/tooltips'
const Buttons = (props: any) => {
  return (
    <button ref={props.ref} id={props?.id} disabled={props.disabled} type={props?.type || 'button'} aria-label={props['aria-label'] || props?.label} className={`btn ${props?.className}`} value={props?.showhide} onMouseDown={props?.onMouseDown} onClick={props?.onClick} title={props['aria-label'] || props?.label}>{props?.icon && <span className={`${props?.icon}`}></span>} {props?.label} {props?.ricon && <span className={`${props?.ricon}`}></span>}
      {props?.info && <Tooltip content={props?.info}>
        <span className={props.infoClassName ? `icon-rb-info ps-1 ${props?.infoClassName}` : 'icon-rb-info ps-1 color-primary'}></span>
      </Tooltip>}
    </button>
  )
}
export default (Buttons)
